var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#BABDCC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.457 12.857C.175 12.661 0 12.292 0 11.892V1.108C0 .708.175.34.456.143a.752.752 0 0 1 .905.017L8.568 5.55c.268.201.432.561.432.949 0 .388-.164.748-.432.948L1.36 12.84a.752.752 0 0 1-.904.017z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleArrow);
export default __webpack_public_path__ + "static/media/single-arrow.715de75c62b6ca068497c69f7d100195.svg";
export { ForwardRef as ReactComponent };